(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("$"), require("jQuery"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "React", "loadjs", "ecCom", "$", "jQuery", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ecCom"] = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("$"), require("jQuery"), require("ReactDOM"));
	else
		root["ecCom"] = factory(root["antd"], root["React"], root["loadjs"], root["ecCom"], root["$"], root["jQuery"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_55__, __WEBPACK_EXTERNAL_MODULE_554__, __WEBPACK_EXTERNAL_MODULE_145__, __WEBPACK_EXTERNAL_MODULE_602__, __WEBPACK_EXTERNAL_MODULE_53__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition